import { gql, MutationFunction } from '@apollo/client';

export const UpdateDomain = gql`
mutation UpdateDomain($code:String!, $name: String!, $input:DomainUpdateInput) {
	updateDomain(organizationCode: $code, domainName: $name, input: $input)
}
`;

export type UpdateOrganizationDomainMutation = MutationFunction<
  UpdateOrganizationDomainData,
  UpdateOrganizationDomainVariables
>;